module.exports = __webpack_public_path__ + "static/media/add-icon.0e3e08bc.svg";